import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './assets/locales/en/translation.json';
import translationAR from './assets/locales/ar/translation.json';

const fallbackLng = ['en'];
// When the Arabic switcher is hidden there is no way back to English, so
// Arabic must never be auto-selected from the browser or URL.
const availableLanguages = import.meta.env.VITE_HIDE_ARABIC
  ? ['en']
  : ['en', 'ar'];

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    supportedLngs: availableLanguages,

    detection: {
      // Translation resources are bundled; never build a network URL from a
      // detected language value.
      caches: [],
      // Reduce regional codes to the base language so a browser list like
      // ['en-US', 'ar'] resolves to 'en' instead of skipping to the exact 'ar'.
      convertDetectedLanguage: (lng) => lng.split('-')[0],
    },

    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
